import React from 'react';
export function General() {
  return <div data-id="element-2631">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2632">
        General Settings
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2633">
        Manage your account and application preferences
      </p>

      <div className="space-y-6" data-id="element-2634">
        {/* Company Information */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2635">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2636">
            Company Information
          </h2>
          <div className="grid grid-cols-2 gap-4" data-id="element-2637">
            <div data-id="element-2638">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2639">
                Company Name
              </label>
              <input type="text" placeholder="Enter company name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2640" />
            </div>
            <div data-id="element-2641">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2642">
                Industry
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2643">
                <option data-id="element-2644">Automotive</option>
                <option data-id="element-2645">Technology</option>
                <option data-id="element-2646">Retail</option>
              </select>
            </div>
          </div>
        </div>

        {/* Regional Settings */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2647">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2648">
            Regional Settings
          </h2>
          <div className="grid grid-cols-2 gap-4" data-id="element-2649">
            <div data-id="element-2650">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2651">
                Timezone
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2652">
                <option data-id="element-2653">Asia/Kolkata (IST)</option>
                <option data-id="element-2654">America/New_York (EST)</option>
                <option data-id="element-2655">Europe/London (GMT)</option>
              </select>
            </div>
            <div data-id="element-2656">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2657">
                Currency
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2658">
                <option data-id="element-2659">INR (₹)</option>
                <option data-id="element-2660">USD ($)</option>
                <option data-id="element-2661">EUR (€)</option>
              </select>
            </div>
          </div>
        </div>

        <div className="flex justify-end" data-id="element-2662">
          <button className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors font-medium" data-id="element-2663">
            Save Changes
          </button>
        </div>
      </div>
    </div>;
}